export const SUB_CATEGORY_CONFIG = {
  SUB_CATEGORY_LIST: {
    endPoint: 'subcategory',
    method: 'GET',
    baseUrlKey: 'inventoryApiUrl',
  },
} 